import type { Task } from '@/services/types/client-intake-types';

import { CrashingOutAgentStatusCell } from './CrashingOutAgentStatusCell';
import { RecordsRequestAgentStatusCell } from './RecordsRequestAgentStatusCell';

export const TaskAgentStatusCell = ({ task }: { task: Task }) => {
  if (task.treatment_record_request?.id) {
    return <RecordsRequestAgentStatusCell task={task} />;
  }

  return <CrashingOutAgentStatusCell task={task} />;
};
